/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import { useMutation, useQuery } from 'react-query';
import { KTSVG, toAbsoluteUrl } from '../../../../../_metronic/helpers';
import { LoadingSpan } from '../../../components/Loadings/loadingSpan';
import { Loading } from '../../../components/Loadings/loading';
import useSize from '../../../../hooks/useSize';
import { SelectGlobal } from '../../../components/SelectGlobal';
import { useToast } from '../../../components/Toats';
import { getUnitConsumerAll } from '../../../../services/unitConsumerService';
import DateSelector from '../../../reports/reportsDetails/TableReports/components/DateInput';
import { NotImported } from '../../../components/NotInformat';
import { DateCompleteMesAno, getCurrentMonthFormatted } from '../../../../utils/date';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { getCreateInvoicesConcessionaires, getCreateInvoicesConcessionairesV2, getCreateInvoicesReferences, putInvoiceExtractBullQueue } from '../../../../services/invoices';
import { getProcessAtual } from '../../../../services/processService';

interface FileWithPreview {
  id: string;
  file: File;
  name: string;
  size: number;
  type: string;
}

type Props = {
    show: boolean;
    handleClose: () => void;
}

const validationSchema = Yup.object().shape({
  monthsToReference: Yup.date().required('O mês de referência é obrigatório'),
  monthsToImport: Yup.number().required('O número de meses a importar é obrigatório'),
  selectedFiles: Yup.array().of(Yup.object().shape({
    id: Yup.string().required('O ID é obrigatório'),
    file: Yup.object().shape({
      name: Yup.string().required('O nome do arquivo é obrigatório'),
    }),
  })),
});

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalImportPreviousInvoices = ({show, handleClose}: Props) => {

  const { toggleToast } = useToast();
  const [selectedUnitConsumer, setSelectedUnitConsumer] = useState<string | null>(null);
  const [typeImportations, setTypeImportations] = useState<"ANEXAR" | "CONCESSIONARIA" | "MANUAL">("ANEXAR");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [loading, setLoading] = useState(false);
  const {width: largura} = useSize();

  const [initialValues, setInitialValues] = useState({
    monthsToReference: new Date(),
    monthsToImport: 12,
    selectedFiles: [] as FileWithPreview[]
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnChange: false,
    onSubmit: () => {},
  });

  const getStatusBadgeColor = (status: string): string => {
    const colorMap: { [key: string]: string } = {
      "MONITORADA": "success",
      "NÃO MONITORADA": "danger",
      "EM MANUTENÇÃO": "info"
    };
    return colorMap[status] || "secondary";
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const generateUniqueId = () => {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  };

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const newFiles: FileWithPreview[] = Array.from(files).map((file) => ({
        id: generateUniqueId(),
        file: file,
        name: file.name,
        size: file.size,
        type: file.type,
      }));
      //setSelectedFiles((prev) => [...prev, ...newFiles]);
      formik.setValues({
        ...formik.values,
        selectedFiles: newFiles,
      });
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const removeFile = (id: string) => {
    //setSelectedFiles((prev) => prev.filter((file) => file.id !== id));
    formik.setValues({
      ...formik.values,
      selectedFiles: formik.values.selectedFiles.filter((file) => file.id !== id),
    });
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getFileIcon = (fileName: string): string => {
    const ext = fileName.split('.').pop()?.toLowerCase() || '';
    const iconMap: { [key: string]: string } = {
      jpg: 'bi-filetype-jpg',
      jpeg: 'bi-filetype-jpg',
      png: 'bi-filetype-png',
      pdf: 'bi-filetype-pdf',
      doc: 'bi-filetype-doc',
      docx: 'bi-filetype-doc',
      xls: 'bi-filetype-xls',
      xlsx: 'bi-filetype-xls',
      default: 'bi-file-earmark'
    };
    return iconMap[ext] || iconMap.default;
  };

  const calculateMonthsDifference = (): number => {
    const now = new Date();
    const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const selectedDate = new Date(formik.values.monthsToReference);
    
    const yearsDiff = previousMonth.getFullYear() - selectedDate.getFullYear();
    const monthsDiff = previousMonth.getMonth() - selectedDate.getMonth();
    
    const totalMonths = yearsDiff * 12 + monthsDiff + 1;
    return totalMonths > 0 ? totalMonths : 0;
  };

  const monthsToCreate = calculateMonthsDifference();

  const { data: unitConsumers = [], isLoading: loadingUnitConsumers } = useQuery<any>(
    ["getUnitConsumersForImport", show],
    async () => {
      if (!show) return [];
      const myUnitConsumers = await getUnitConsumerAll();
      return myUnitConsumers;
    },
    {
      enabled: show,
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar as unidades consumidoras!", "error");
      },
    }
  );

  const { data: processAtual = null, isLoading: loadingProcessAtual, refetch: refetchProcessAtual } = useQuery<any>(
    ["getProcessAtual", show, selectedUnitConsumer],
    async () => {
     if(selectedUnitConsumer){
      
      const filters_pending = {
        idUnitConsumer: selectedUnitConsumer,
        status: "PENDENTE",
        cod_ref: 1,
      }
      let process = await getProcessAtual(filters_pending);

      if(!process){
        const filters_processing = {
          idUnitConsumer: selectedUnitConsumer,
          status: "PROCESSANDO",
          cod_ref: 1,
        }
        process = await getProcessAtual(filters_processing);
      }

      if(!process){
        const filters_processing = {
          idUnitConsumer: selectedUnitConsumer,
          status: "CONCLUIDO",
          cod_ref: 1,
        }
        process = await getProcessAtual(filters_processing);
      }

      if(!process){
        const filters_processing = {
          idUnitConsumer: selectedUnitConsumer,
          status: "FALHOU",
          cod_ref: 1,
        }
        process = await getProcessAtual(filters_processing);
      }
      
      if(process && process.status === "PROCESSANDO"){
        setLoading(true);
      }else{
        setLoading(false);
      }

      return process;
     }
     return null;
    },
    {
      enabled: show && !!selectedUnitConsumer,
      refetchInterval: show && selectedUnitConsumer ? 10000 : false,
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao status do processo de importação de faturas!", "error");
      },
    }
  );

  const postInvoicesReferencesMutation = useMutation(
    async () => {
      const filters = {
        dateInit: DateCompleteMesAno(formik.values.monthsToReference),
        dateEnd: DateCompleteMesAno(new Date().toDateString()),
        unitConsumer: selectedUnitConsumer,
      }
      const response = await getCreateInvoicesReferences(filters);
      return response;
    },
    {
      onSuccess: () => {
        toggleToast("Solicitação adicionada a fila de processamento. Aguarde!", "info");
        //closed();
        refetchProcessAtual();
      },
      onError: () => {
        toggleToast("Erro ao adicionar solicitação a fila de processamento. Tente novamente!", "error");
        //closed();
        refetchProcessAtual();
      },
    }
  );

  const postInvoicesConcessionairesMutation = useMutation(
    async () => {
      const filters = {
        numberOfInvoices: formik.values.monthsToImport,
        unitConsumer: selectedUnitConsumer,
      }
      const response = await getCreateInvoicesConcessionairesV2(filters);
      return response
    },
    {
      onSuccess: () => {
        toggleToast("Solicitação adicionada a fila de processamento. Aguarde!", "info");
        refetchProcessAtual();
      },
      onError: () => {
        toggleToast("Erro ao adicionar solicitação a fila de processamento. Tente novamente!", "error");
        refetchProcessAtual();
      },
    }
  );

  const postInvoicesExtractionMutation = useMutation(
    async () => {
      const filters = {
        files: formik.values.selectedFiles,
        idUnitConsumer: selectedUnitConsumer,
      }
      const response = await putInvoiceExtractBullQueue(filters);
      return response
    },
    {
      onSuccess: () => {
        toggleToast("Solicitação adicionada a fila de processamento. Aguarde!", "info");
        refetchProcessAtual();
      },
      onError: () => {
        toggleToast("Erro ao adicionar solicitação a fila de processamento. Tente novamente!", "error");
        refetchProcessAtual();
      },
    }
  );

  const selectedUnitConsumerData = unitConsumers.find((uc: any) => uc.id === selectedUnitConsumer) || null;

  const closed = () => {
    setLoading(false);
    //setSelectedFiles([]);
    setSelectedUnitConsumer(null);
    setTypeImportations("ANEXAR");
    //setMonthsToImport(12);
    formik.setValues(initialValues);
    handleClose();
  }

  const handleSubmit = () => {
    if(typeImportations === "ANEXAR"){
      postInvoicesExtractionMutation.mutate();
    } else if(typeImportations === "CONCESSIONARIA"){
      postInvoicesConcessionairesMutation.mutate();
    } else if(typeImportations === "MANUAL"){
      postInvoicesReferencesMutation.mutate();
    }
  };

  return createPortal(
    <Modal
      id='kt_modal_import_previous_invoices'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={closed}
      backdrop={true}
    >

      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Importar faturas anteriores</span>
        </h3>

        <div 
          className={`btn btn-sm btn-icon btn-active-color-primary`} 
          onClick={closed}
        >
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
          <SelectGlobal 
              itens={unitConsumers}
              buttonAll={true}
              textSearch={"Buscar unidade consumidora"}
              textButtonInit={"Selecione a unidade consumidora"}
              labelKey='name'
              valueKey='id'
              typeIcon='svg'
              linkIcon='/media/icons/duotune/general/gen001.svg'
              sizeIconSvg='2'
              value={selectedUnitConsumer ? selectedUnitConsumer : ""}
              //className={styles.selectPortal}
              onChange={(value: string) => {
                  setSelectedUnitConsumer(value)
                  setLoading(false);
              }}
          />

          {processAtual && processAtual.status === "PENDENTE" && (
            <div className='notice d-flex bg-light-info rounded border-info border border-dashed flex-shrink-0 p-6 mb-5 mt-5'>  
              <LoadingSpan style={{marginLeft: '0.5rem'}} className='me-4 text-info'/>

              <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                <div className='mb-3 mb-md-0 fw-bold'>
                  <div className='fs-6 text-info pe-7'>
                    Solicitação de importação de faturas da unidade consumidora "{selectedUnitConsumerData?.name || "Não informada"}" adicionada à fila de importação. Aguarde!
                  </div>
                </div>
              </div>
            </div>
          )}

          {processAtual && processAtual.status === "CONCLUIDO" && (
            <div className='notice d-flex bg-light-success rounded border-success border border-dashed flex-shrink-0 p-6 mb-5 mt-5'>  
              <KTSVG className='svg-icon-1 svg-icon-success me-2' path='/media/icons/duotune/arrows/arr012.svg' />
              <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                <div className='mb-3 mb-md-0 fw-bold'>
                  <div className='fs-6 text-success pe-7'>
                    Solicitação de importação de faturas da unidade consumidora "{selectedUnitConsumerData?.name || "Não informada"}" finalizada: {processAtual.description || "Não informado"}.
                  </div>
                </div>
              </div>
            </div>
          )}

          {processAtual && processAtual.status === "FALHOU" && (
            <div className='notice d-flex bg-light-danger rounded border-danger border border-dashed flex-shrink-0 p-6 mb-5 mt-5'>  
              <KTSVG className='svg-icon-1 svg-icon-danger me-2' path='/media/icons/duotune/arrows/arr061.svg'  />
              <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                <div className='mb-3 mb-md-0 fw-bold'>
                  <div className='fs-6 text-danger pe-7'>
                    Solicitação de importação de faturas da unidade consumidora "{selectedUnitConsumerData?.name || "Não informada"}" finalizada: {processAtual.description || "Não informado"}.
                  </div>
                </div>
              </div>
            </div>
          )}


          <div style={{position: 'relative'}}>
            {processAtual && processAtual.status === "PROCESSANDO" ? (
              <div 
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10,
                  borderRadius: '0.475rem'
                }}
              >
                <div className='d-flex flex-column align-items-center gap-3'>
                  <Loading myClass='spinner-border text-primary' style={{width: '3rem', height: '3rem'}}/>
                  <span className='text-muted fw-semibold'>Processando...</span>
                </div>
              </div>
            ) : processAtual && processAtual.status === "PENDENTE" ? (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10,
                  borderRadius: '0.475rem'
                }}
              ></div>
            ) : <></>}

            {selectedUnitConsumer && (
              <div className='mt-7'>
                <label className='form-label fw-bold mb-4'>Selecione o método de importação:</label>
                <div className='d-flex flex-row gap-4'>
                  <div className='form-check form-check-custom form-check-solid'>
                    <input 
                      className={`form-check-input ${typeImportations === "ANEXAR" ? 'bg-primary' : 'bg-secondary'}`}
                      type='checkbox'
                      checked={typeImportations === "ANEXAR"}
                      disabled={loading}
                      onChange={(e) => e.target.checked ? setTypeImportations("ANEXAR") : () => {}}
                    />
                    <label className='form-check-label fw-semibold'>
                      Anexar manualmente
                    </label>
                  </div>

                  <div className='form-check form-check-custom form-check-solid'>
                    <input 
                      className={`form-check-input ${typeImportations === "CONCESSIONARIA" ? 'bg-primary' : 'bg-secondary'}`}
                      type='checkbox'
                      checked={typeImportations === "CONCESSIONARIA"}
                      disabled={loading}
                      onChange={(e) => e.target.checked ? setTypeImportations("CONCESSIONARIA") : () => {}}
                    />
                    <label className='form-check-label fw-semibold'>
                      Buscar na concessionária
                    </label>
                  </div>

                  <div className='form-check form-check-custom form-check-solid'>
                    <input 
                      className={`form-check-input ${typeImportations === "MANUAL" ? 'bg-primary' : 'bg-secondary'}`}
                      type='checkbox'
                      checked={typeImportations === "MANUAL"}
                      disabled={loading}
                      onChange={(e) => e.target.checked ? setTypeImportations("MANUAL") : () => {}}
                    />
                    <label className='form-check-label fw-semibold'>
                      Criar referências manualmente
                    </label>
                  </div>
                </div>
              </div>
            )}

            {selectedUnitConsumer && typeImportations === "ANEXAR" && (
              <div className='mt-7'>
                <div className='card border border-gray-300 border-dashed rounded p-4'>
                  <div className='border border-gray-200 border-dashed rounded p-1 mb-4'>
                    <div className="d-flex align-items-center justify-content-center" style={{width: '100%', height: '6rem'}}>
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileSelect}
                        style={{ display: 'none' }}
                        multiple
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                      />

                      <button
                        onClick={handleButtonClick}
                        style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}
                        className='btn btn-sm btn-light-primary text-hover-white'
                        type='button'
                        disabled={loading}
                      >
                        <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-2x' />
                        <h3 className='card-title align-items-start flex-column'>
                          <span className='mt-1 fw-semibold fs-7'>Clique para selecionar faturas</span>
                        </h3>
                      </button>
                    </div>
                  </div>

                  <div 
                    className='card border border-gray-300 border-dashed rounded p-4' 
                    style={{maxHeight: '200px', overflow: 'auto'}}
                  >
                    {formik.values.selectedFiles.length <= 0 && (
                      <div className='bg-light rounded' 
                        style={{
                          width: '100%', 
                          padding: '2rem',
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          gap: '0.5rem',
                          flexDirection: 'column'
                        }}
                      >
                        <KTSVG
                          path="/media/icons/duotune/general/gen004.svg"
                          className='svg-icon-3x me-1'
                        />
                        <h3 className='card-title d-flex align-items-center justify-content-center flex-column'>
                          <span className='text-muted fw-semibold fs-7'>Nenhuma fatura selecionada</span>
                        </h3>
                      </div>
                    )}

                    {formik.values.selectedFiles.length > 0 && (
                      <div className='d-flex flex-column gap-3'>
                        {formik.values.selectedFiles.map((fileItem) => (
                          <div key={fileItem.id} className='d-flex align-items-center gap-3 p-2 bg-light rounded'>
                            <div className='symbol symbol-40px symbol-circle'>
                              <span className={`symbol-label bg-light-primary text-primary fs-9 fw-bolder`}>
                                <i className={`bi ${getFileIcon(fileItem.name)} fs-1`}></i>
                              </span>
                            </div>
                            <div className='flex-grow-1'>
                              <div className='d-flex justify-content-start flex-column'>
                                <span className='text-dark fw-semibold d-block fs-7'>
                                  {fileItem.name}
                                </span>
                                <span className='text-muted fw-semibold fs-8'>
                                  {formatFileSize(fileItem.size)}
                                </span>
                              </div>
                            </div>
                            <div>
                              <button
                                onClick={() => removeFile(fileItem.id)}
                                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                type='button'
                                disabled={loading}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/general/gen027.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Contador de arquivos */}
                  {formik.values.selectedFiles.length > 0 && (
                    <div className='d-flex justify-content-between align-items-center mt-3'>
                      <span className='text-muted fs-7'>
                        {formik.values.selectedFiles.length} {formik.values.selectedFiles.length === 1 ? 'fatura selecionada' : 'faturas selecionadas'}
                      </span>
                      <button
                        onClick={() => formik.setValues({...formik.values, selectedFiles: []})}
                        className='btn btn-sm btn-light-danger'
                        type='button'
                        disabled={loading}
                      >
                        Limpar todos
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {
            selectedUnitConsumer 
            && typeImportations === "CONCESSIONARIA" 
            && (
              <div className='mt-7'>
                {(
                  selectedUnitConsumerData?.concessioraire?.type_monitor !== "CREDENCIAIS" ||
                  selectedUnitConsumerData?.concessioraire?.status_mon_aut === "NÃO MONITORADA") && (
                  
                  <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed flex-shrink-0 p-6 mb-5'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2tx svg-icon-warning me-4'
                    />
                    <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                      <div className='mb-3 mb-md-0 fw-bold'>
                        <div className='fs-6 text-warning pe-7'>
                          A concessionária {selectedUnitConsumerData?.concessioraire?.name || "Não informada"} não disponivel para importação de faturas do tipo "Buscar na concessioária".
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className='card border border-gray-300 border-dashed rounded p-4'>
                  <div className='d-flex align-items-center mb-5 p-4 bg-light rounded'>
                    <div className='d-flex align-items-center' style={{flex: '4'}}>
                      <div className={`symbol symbol-${largura < 1200 ? '40px' : '70px'} me-5`}>
                        <span className='symbol-label' style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                          <div className={`symbol symbol-${largura < 1200 ? '40px' : '50px'}`} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            {/* <KTSVG path="/media/icons/duotune/finance/fin001.svg" className="svg-icon-muted svg-icon-3hx" /> */}
                            <img src={toAbsoluteUrl('https://res.cloudinary.com/deq3ehxe3/image/upload/v1771533247/1275576_zn46s3.png')} alt='Metornic' className='svg-icon-muted' />
                          </div>
                        </span>
                      </div>
                      <div className='d-flex flex-column'>
                        <span className={`text-dark fs-${largura < 1200 ? '7' : '6'} fw-bold`}>
                          {selectedUnitConsumerData?.concessioraire?.name || "Concessionária não informada"}
                        </span>
                        <span className={`text-muted fw-semibold fs-${largura < 1200 ? '7' : '6'}`}>
                          Tipo de monitoramento: {selectedUnitConsumerData?.concessioraire?.type_monitor || <NotImported className="fs-6 text-gray-400 text-hover-primary"/>}
                        </span>
                        {selectedUnitConsumerData?.concessioraire?.status_mon_aut && (
                          <span className={`badge badge-light-${getStatusBadgeColor(selectedUnitConsumerData?.concessioraire?.status_mon_aut)} fw-semibold fs-8 mt-1`}>
                            {selectedUnitConsumerData?.concessioraire?.status_mon_aut}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='mb-3'>
                    <label className='form-label fw-bold'>Quantos meses anteriores deseja importar?</label>
                    <div className='d-flex align-items-center gap-3'>
                      <input 
                        type='number'
                        className='form-control form-control-solid'
                        style={{maxWidth: '150px'}}
                        value={formik.values.monthsToImport}
                        min={1}
                        max={60}
                        disabled={
                          loading ||
                          (selectedUnitConsumerData?.concessioraire?.type_monitor !== "CREDENCIAIS"
                          && selectedUnitConsumerData?.concessioraire?.status_mon_aut !== "NÃO MONITORADA")
                        }
                        onChange={(e) => formik.setFieldValue('monthsToImport', Number(e.target.value))}
                      />
                      <span className='text-muted fs-7'>
                        {formik.values.monthsToImport === 1 ? 'mês' : 'meses'} anteriores a partir de {getCurrentMonthFormatted()} (atual)
                      </span>
                    </div>
                    <div className='text-muted fs-8 mt-2'>
                      <i className='bi bi-info-circle me-1'></i>
                      Serão importadas as faturas dos últimos {formik.values.monthsToImport} {formik.values.monthsToImport === 1 ? 'mês' : 'meses'}.
                    </div>
                  </div>
                </div>
              </div>
            )}

            {selectedUnitConsumer && typeImportations === "MANUAL" && (
              <div className='mt-7'>
                <div className='card border border-gray-300 border-dashed rounded p-4'>
                  <div className='mb-3'>
                    <label className='form-label fw-bold'>Deseja criar as referências a partir de qual mês?</label>
                    <div className='d-flex align-items-center gap-3'>
                      <span>De</span>
                      <DateSelector 
                        selectedDate={new Date(formik.values.monthsToReference)}
                        setSelectedDate={(date: Date) => formik.setFieldValue('monthsToReference', date)}
                      />
                      <span className='text-muted fs-7'>
                        até o mês anterior a {getCurrentMonthFormatted()} (atual)
                      </span>
                    </div>
                    <div className='text-muted fs-8 mt-2'>
                      <i className='bi bi-info-circle me-1'></i>
                      Serão criadas <strong>{monthsToCreate}</strong> {monthsToCreate === 1 ? 'referência de fatura' : 'referências de faturas'}.
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          
      </div>

      <div className='modal-footer py-lg-10 px-lg-10'>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <button
                type='button'
                className='btn btn-lg btn-light'
                //disabled={loading}
                onClick={closed}
            >
                <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-3 ms-2 me-0'
                />
                <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
            </button>

            <button
                type='button'
                className='btn btn-lg btn-primary'
                disabled={
                  (processAtual && (processAtual.status === "PENDENTE" || processAtual?.status === "PROCESSANDO")) ||
                  loadingUnitConsumers ||
                  loading || 
                  loadingProcessAtual ||
                  postInvoicesConcessionairesMutation.isLoading ||
                  postInvoicesReferencesMutation.isLoading ||
                  postInvoicesExtractionMutation.isLoading ||

                  (typeImportations === "ANEXAR" && formik.values.selectedFiles.length <= 0) ||
                  (typeImportations === "CONCESSIONARIA" && (
                    formik.values.monthsToImport <= 0 ||
                    selectedUnitConsumerData?.concessioraire?.type_monitor !== "CREDENCIAIS" ||
                    selectedUnitConsumerData?.concessioraire?.status_mon_aut === "NÃO MONITORADA"
                  )) ||
                  (typeImportations === "MANUAL" && monthsToCreate <= 0)
                }
                onClick={() => {
                  //setLoading(true)

                  handleSubmit();
                }}
            >
                Importar Faturas
                {
                    loading ||
                    postInvoicesConcessionairesMutation.isLoading ||
                    postInvoicesReferencesMutation.isLoading ||
                    postInvoicesExtractionMutation.isLoading
                    ? 
                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                    :
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                    />
                }
            </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalImportPreviousInvoices}

